// extracted by mini-css-extract-plugin
module.exports = {"container":"i_ZX","header":"i_ZY","avatar":"i_ZZ","image":"i_Za","body":"i_Zb","bubbles":"i_Zc","plural":"i_Zd","singular":"i_Ze","bubble":"i_Zf"};